module.exports = __webpack_public_path__ + "media/categories/1028-77465ec0.svg";